const comparisonRows = [
  { aspect: 'Цель', training: 'Передать знания по одной теме', program: 'Решить бизнес-задачу через развитие компетенций', academy: 'Построить непрерывную систему развития в компании' },
  { aspect: 'Длительность', training: '1-3 дня', program: '2-6 месяцев (несколько модулей)', academy: 'Постоянно действующая система' },
  { aspect: 'Диагностика', training: 'Отсутствует или минимальна', program: 'Глубокий аудит компетенций и KPI', academy: 'Постоянный мониторинг компетенций' },
  { aspect: 'Практика', training: '20-30% времени', program: '80% времени, межмодульные задания', academy: 'Встроена в рабочие процессы' },
  { aspect: 'Оценка', training: 'Анкета обратной связи', program: 'KPI до/после, модель Киркпатрика', academy: 'Сквозная система метрик и KPI' },
  { aspect: 'Сопровождение', training: 'Нет', program: '2-3 месяца после обучения', academy: 'Постоянное (наставники, коучи)' },
  { aspect: 'Результат', training: 'Знания', program: 'Изменение поведения и KPI', academy: 'Культура непрерывного развития' },
];

export default function WhatIsCorporateProgram() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Что такое корпоративная программа обучения
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Не стоит путать разовый тренинг, программу обучения и корпоративную академию — это три разных уровня развития персонала
        </p>

        <div className="overflow-x-auto mb-14">
          <table className="w-full border-collapse bg-white rounded-2xl overflow-hidden shadow-sm">
            <thead>
              <tr className="bg-teal-600 text-white">
                <th className="p-4 text-left text-sm font-semibold whitespace-nowrap">Параметр</th>
                <th className="p-4 text-left text-sm font-semibold whitespace-nowrap">Отдельный тренинг</th>
                <th className="p-4 text-left text-sm font-semibold whitespace-nowrap">Программа обучения</th>
                <th className="p-4 text-left text-sm font-semibold whitespace-nowrap">Корпоративная академия</th>
              </tr>
            </thead>
            <tbody>
              {comparisonRows.map((row, i) => (
                <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}>
                  <td className="p-4 text-sm font-semibold text-gray-900 border-b border-gray-100 whitespace-nowrap">{row.aspect}</td>
                  <td className="p-4 text-sm text-gray-700 border-b border-gray-100">{row.training}</td>
                  <td className="p-4 text-sm text-teal-700 bg-teal-50/70 border-b border-gray-100 font-medium">{row.program}</td>
                  <td className="p-4 text-sm text-gray-700 border-b border-gray-100">{row.academy}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="space-y-6">
          <div className="bg-white rounded-2xl p-8 border border-gray-100">
            <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
              <span className="w-8 h-8 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-flashlight-line text-orange-500"></i>
              </span>
              Отдельный тренинг — точечное воздействие
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Разовое мероприятие, которое решает одну конкретную задачу: познакомить с новым продуктом, отработать навык переговоров, провести командообразование. Эффект краткосрочный — без системы внедрения знания забываются в течение 2-4 недель.{' '}
              <a href="/enciklopediya-korporativnogo-obucheniya/chto-takoe-korporativnoe-obuchenie" className="text-teal-600 font-semibold underline hover:text-teal-700">Тренинг</a> полезен как элемент программы, но не как самостоятельное решение для развития компании.
            </p>
          </div>

          <div className="bg-teal-50/70 rounded-2xl p-8 border border-teal-200">
            <h3 className="text-xl font-bold text-teal-800 mb-4 flex items-center gap-3">
              <span className="w-8 h-8 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-stack-line text-white"></i>
              </span>
              Программа обучения — системное развитие
            </h3>
            <p className="text-teal-800/80 leading-relaxed">
              Это несколько взаимосвязанных модулей, которые последовательно развивают компетенции сотрудников. Программа всегда начинается с диагностики, включает практические задания между модулями, оценку результатов и посттренинговое сопровождение. Именно программа даёт измеримый бизнес-результат, потому что навыки не просто передаются, а внедряются в работу.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 border border-gray-100">
            <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
              <span className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-building-4-line text-purple-500"></i>
              </span>
              Корпоративная академия — культура развития
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Высший уровень — создание внутренней экосистемы обучения. Включает: корпоративные стандарты, базу знаний, внутренних тренеров, систему наставничества, регулярную оценку компетенций.{' '}
              <a href="/enciklopediya-korporativnogo-obucheniya/korporativnaya-akademiya" className="text-teal-600 font-semibold underline hover:text-teal-700">Корпоративная академия</a> не зависит от внешних провайдеров и работает непрерывно. Это долгосрочная инвестиция в развитие компании, которая окупается через рост качества, снижение текучести и ускорение адаптации.
            </p>
          </div>
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-600 leading-relaxed max-w-3xl mx-auto">
            Большинству компаний на начальном этапе не нужна полноценная академия. Достаточно грамотно спроектированной <strong>программы обучения</strong>, которая решает конкретные бизнес-задачи и даёт измеримый результат. С неё и стоит начинать.
          </p>
        </div>
      </div>
    </section>
  );
}